import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { CardMedia } from "@mui/material";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
type ImageType = {
  src: string;
  alt: string;
};

function NextArrow(props: any) {
  const { onClick } = props;
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        top: "50%",
        right: "-48px",
        transform: "translate(-50%, -50%)",
        zIndex: 2,
        height: "16px",
        width: "16px",
        padding: "4px",
        borderRadius: "52%",
        background: "#fdd025",
        transition: "opacity 0.3s ease",
      }}
      onClick={onClick}
      onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.8")}
      onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
    >
      <KeyboardDoubleArrowRightIcon />
    </div>
  );
}

function PrevArrow(props: any) {
  const { onClick } = props;
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        top: "50%",
        left: "-24px",
        transform: "translate(-50%, -50%)",
        zIndex: 2,
        height: "16px",
        width: "16px",
        padding: "4px",
        borderRadius: "52%",
        background: "#fdd025",
        transition: "opacity 0.3s ease",
      }}
      onClick={onClick}
      onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.8")}
      onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
    >
      <KeyboardDoubleArrowLeftIcon />
    </div>
  );
}

const ImageSlider = ({ images }: { images: Array<ImageType> }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  const ensureMinimumImages = (images: Array<ImageType>): Array<ImageType> => {
    const minImages = 2;
    while (images?.length < minImages) {
      images = [...images, ...images.slice(0, minImages - images.length)];
    }
    return images;
  };

  const normalizedImages = ensureMinimumImages(images);

  return (
    <div className="slider-container">
      <Slider {...settings}>
        {normalizedImages?.map((image, index) => (
          <CardMedia
            key={index}
            component="img"
            // height="360px"
            image={image.src}
            alt={image.alt}
            sx={{ objectFit: "contain",  maxHeight:"500px" }}
          />
        ))}
      </Slider>
    </div>
  );
};

export default ImageSlider;
